import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]
  static values = {
    mode: String // 'text' or 'html'
  }

  connect() {
    if (!["text", "html"].includes(this.modeValue)) {
      this.modeValue = "text" // Default fallback
    }
  }

  copy(event) {
    event.preventDefault()

    if (!this.hasTableTarget) {
      console.warn("[TableCopyController] No table target found!")
      return
    }

    const table = this.tableTarget

    if (this.modeValue === "html") {
      const clonedTable = table.cloneNode(true)
      this.inlineStyles(clonedTable)
      const html = clonedTable.outerHTML

      navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([clonedTable.textContent], { type: "text/plain" })
        })
      ]).then(() => {
        console.log("[TableCopyController] Styled HTML table copied to clipboard.")
      }).catch(err => {
        console.error("[TableCopyController] Failed to copy HTML:", err)
      })

    } else {
      // Plain text version
      const rows = Array.from(table.querySelectorAll("tr"))
      const text = rows.map(row => {
        const cells = Array.from(row.querySelectorAll("th, td"))
        return cells.map(cell => cell.textContent.trim()).join("\t")
      }).join("\n")

      navigator.clipboard.writeText(text)
        .then(() => {
          console.log("[TableCopyController] Plain text table copied to clipboard.")
        })
        .catch(err => {
          console.error("[TableCopyController] Failed to copy plain text:", err)
        })
    }
  }

  inlineStyles(element) {
    const allElements = element.querySelectorAll("*")

    allElements.forEach(el => {
      const computedStyle = window.getComputedStyle(el)
      const styleString = Array.from(computedStyle).map(key => {
        return `${key}: ${computedStyle.getPropertyValue(key)};`
      }).join(" ")
      el.setAttribute("style", styleString)
    })
  }
}
